module.exports = __webpack_public_path__ + "f0568ce2fb0066b453fdc8f23af1a6e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-basic-3.png
// module id = 1561
// module chunks = 0